

























































import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppFileUploader from '@/components/AppFileUploader.vue'
import { Case } from '@/modules/Case/interfaces/case'
import { dateTimeToDisplay } from '@/utils/dateTime'
import { caseType } from '@/modules/Case/helpers/case'
import S3Handler from '@/mixins/s3'
import { mixins } from 'vue-class-component'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppFileUploader
  }
})
export default class CaseDetailDetail extends mixins(S3Handler) {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  dateTimeToDisplay = dateTimeToDisplay

  caseType = caseType

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  routeToAccountDetail () {
    if (this.caseInfo && this.caseInfo.account) {
      this.$router.push({
        name: 'AccountDetailDetail',
        params: {
          id: this.caseInfo.account.id + ''
        }
      })
    }
  }

  routeToContactDetail () {
    if (this.caseInfo && this.caseInfo.primaryContact) {
      this.$router.push({
        name: 'ContactDetailDetail',
        params: {
          id: this.caseInfo.primaryContact.id + ''
        }
      })
    }
  }

  parseNote (note: string) {
    return note ? note.split('\n') : []
  }

  stopPreventDefault (e: Event) {
    e.preventDefault()
    e.stopPropagation()
  }
}
